import FormCatalogoIncidencias from "./form";

export default function AgregarACatalogoIncidencias() {
    return (
        <FormCatalogoIncidencias/>
    )
}